import React from "react";
import { Input } from "@shadcn-in-nx/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shadcn-in-nx/ui/select";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

const TRIGGER_TYPES = ["TIME", "WEBHOOK", "API", "EVENT", "TOOL", "APP", "EMAIL", "WHATSAPP"];

function MonitoringFilters({
    searchQuery, onSearchChange,
    triggerType, onTriggerTypeChange,
    workflowId, onWorkflowIdChange, workflows,
    dateFrom, onDateFromChange,
    dateTo, onDateToChange,
    totalCount, isLoading,
}) {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col sm:flex-row gap-2 items-end flex-wrap">
            <div className="relative flex-1 min-w-[180px]">
                <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 h-3.5 w-3.5" />
                <Input placeholder={t("monitoring.filter.searchPlaceholder")} value={searchQuery} onChange={(e) => onSearchChange(e.target.value)} className="pl-8 h-8 text-xs" />
            </div>
            <Select value={workflowId} onValueChange={onWorkflowIdChange}>
                <SelectTrigger className="w-full sm:w-[180px] h-8 text-xs">
                    <SelectValue placeholder={t("monitoring.filter.workflowAll")} />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="all">{t("monitoring.filter.workflowAll")}</SelectItem>
                    {workflows.map((wf) => (
                        <SelectItem key={wf.id} value={wf.id}>{wf.name}</SelectItem>
                    ))}
                </SelectContent>
            </Select>
            <Select value={triggerType} onValueChange={onTriggerTypeChange}>
                <SelectTrigger className="w-full sm:w-[140px] h-8 text-xs">
                    <SelectValue placeholder={t("monitoring.filter.triggerAll")} />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="all">{t("monitoring.filter.triggerAll")}</SelectItem>
                    {TRIGGER_TYPES.map((type) => (
                        <SelectItem key={type} value={type}>{t(`monitoring.trigger.${type.toLowerCase()}`)}</SelectItem>
                    ))}
                </SelectContent>
            </Select>
            <Input type="date" value={dateFrom} onChange={(e) => onDateFromChange(e.target.value)} className="w-full sm:w-[130px] h-8 text-xs" />
            <Input type="date" value={dateTo} onChange={(e) => onDateToChange(e.target.value)} className="w-full sm:w-[130px] h-8 text-xs" />
            <span className="text-[11px] text-muted-foreground whitespace-nowrap">
                {!isLoading && totalCount != null && `${totalCount} ${t("monitoring.filter.executions")}`}
            </span>
        </div>
    );
}

export default MonitoringFilters;
